import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store'
import MintUI from 'mint-ui'
import { MessageBox } from 'mint-ui'
import 'mint-ui/lib/style.css'
import '@/common/stylus/index.styl'
import '@/common/font/iconfont.css'
import 'lib-flexible'
import VueWechatTitle from 'vue-wechat-title'
import WechatAuth from 'vue-wechat-auth'
import axios from 'axios'
import md5 from 'js-md5';
import '@/assets/css/my-mint.styl'
import wx from "weixin-js-sdk";
import VueClipboard from 'vue-clipboard2';
import SlideVerify from 'vue-monoplasty-slide-verify';
import LuckDraw from 'vue-luck-draw'

import sensors from '@/assets/js/sensors_config'
Vue.prototype.$sensors = sensors;

Vue.use(LuckDraw)

Vue.use(SlideVerify);
Vue.use(VueWechatTitle)
Vue.use(MintUI)
Vue.use(VueClipboard)
Vue.config.productionTip = false
Vue.prototype.global = {
  app_id:123
};

// /* eslint-disable no-new */
// router.beforeEach((to, from, next) => {
//   // NProgress.start();
//   if (to.path == '/login') {
//     sessionStorage.removeItem('userInfo');
//   }
//   let userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
//   // if (!userInfo && to.path != '/account/login') {
//   //   next({ path: '/account/login' })
//   // } else {
//   //   next()
//   // }                                   //默认可选择暂时不登录
//   next()
// })


axios.defaults.headers['content-type']="application/json"
axios.defaults.transformRequest =[function(data){
  if(data)
  {
    let sign="";
    if (typeof data == "string") {
          sign= getSign(data);
    } else if (typeof data == "object") {
      var arr = [];
      let pro = [ ]  //声明一个空数组
      let $i = 0
  　　for(let key in data){  //取出对象里面的键  添加到数组中
          pro[$i] = key
          $i++
      }
      pro.sort()
      let $j=0
      for (var tem in data) {
          arr.push((pro[$j] + "=" + data[pro[$j]]));
          $j++
      }
      console.log(arr.join(("&")));
      sign=getSign(arr.join(("&")));
    }
    data['sign']=sign;
  }
  return JSON.stringify(data);
}]

function getSign(paramsStr) {
    var url = paramsStr;
    var urlStr = url.split("&").sort().join("&");
    var newUrl = urlStr + '&key=NfrSdNWuyiL7rO4EnqI6dr2fmRs6DP4j';
    return md5(newUrl);
}


// 微信授权插件初始化
Vue.use(WechatAuth , {
  router, // 路由实例对象
  appid: 'wxbc4e86265e5065d8', // 您的微信appid
  responseType: 'code',  // 返回类型，请填写code
  scope: 'snsapi_userinfo', // 应用授权作用域，snsapi_base （不弹出授权页面，直接跳转，只能获取用户openid），snsapi_userinfo （弹出授权页面，可通过openid拿到昵称、性别、所在地。并且，即使在未关注的情况下，只要用户授权，也能获取其信息）
  getCodeCallback (code, next) {
    // 用户同意授权后回调方法
    // code：用户同意授权后，获得code值
    // code说明： code作为换取access_token的票据，每次用户授权带上的code将不一样，code只能使用一次，5分钟未被使用自动过期。
    // next： 无论access_token是否获取成功,一定要调用该方法
    // next说明：next方法接收两个参数
    // 参数1为通过code值请求后端获取到的access_token值，如果获取失败请填入空字符串''
    // 参数2(非必填，默认获取access_token切换到当前路由对象)，指定切换对象 next('/') 或者 next({ path: '/' })
    //console.log(store)

    var usercode=''
    if(store.getters.userInfo.usercode){usercode=store.getters.userInfo.usercode}
    var invitecode=''
    if(sessionStorage.getItem('invitecode')){invitecode=sessionStorage.getItem('invitecode')}
    axios.post('/api/wx/getWxUserInfoByCode', {code:code,state: '',usercode:usercode,invitecode:invitecode},{
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(response => {
      let data = response.data
      if(data.code==200){
        let accessToken = data.data['access_token']
        if (accessToken) {
          store.dispatch('setwxUserInfo',data.data['wxuserdata']);
          store.dispatch('setUserInfo',data.data['userdata']);
          sensors.loginWithKey('$identity_mobile',data.data['userdata'].mobile);
          //let userinfo=JSON.parse(data.data['userdata']);
          //console.log(data.data['userdata']['mobile']);return;
          var referrer = sessionStorage.getItem('referrer');
          if(data.data['userdata']['mobile'] || referrer.indexOf("activityjoin")!=-1 || referrer.indexOf("playerinfo")!=-1 || referrer.indexOf("matchview")!=-1 ||(referrer.indexOf("activityview")!=-1 && sessionStorage.getItem("islike")==1)||(referrer.indexOf("articleview")!=-1 && sessionStorage.getItem("islike")==1))
          {
            sessionStorage.removeItem("islike");
            next(accessToken) // 获取access_toeken成功
          }
          else{
            next(accessToken,{ path: '/account/wxauth' })
          }
        } else {
          $toast(data.msg);
          next('/') // 获取access_token失败
        }
      }else{
        window.localStorage.setItem('wxusermsg', data.msg)
        console.log(data.msg);
        MessageBox({
          title: '提示',
          message: data.msg,
          closeOnClickModal:false,
        }).then(action => {

        });
        next('/')
      }


    }).catch(() => {
      next('/') // ajax出现错误
    })
  }
})

Vue.prototype.wxjsapi = function (url,share,callbackfunction){

  axios.post('/api/wx/getwxjsapi', {"url": url},{
    headers: {
        'Content-Type': 'application/json'
    }
  }).then(response => {
    //console.log(store)
    let data = response.data;
    let jsapi = data.data['jsapi'];
    var shareimg="http://image.haolangtech.com/hdqlogo.jpg";
    if(share.shareimg!=""){
      shareimg=share.shareimg;
    }
    wx.config({
      debug: false,
      appId: jsapi.appId, // 必填，公众号的唯一标识
      timestamp:jsapi.timestamp, // 必填，生成签名的时间戳
      nonceStr: jsapi.nonceStr, // 必填，生成签名的随机串
      signature: jsapi.signature,// 必填，签名，见附录1
      jsApiList: jsapi.jsApiList,
      openTagList:['wx-open-launch-weapp']
    });


    wx.ready(function (){


      const shareinfo = {
        title: share.title,// 分享出去的title
        desc: share.desc,  // 描述信息
        imgUrl: shareimg,  // 分享的小图标
        link: share.url,   // 分享的除去的url
        success: function() {
          if(share.callmethod){
            setTimeout(share.callmethod, 500);
          }
        },
        cancel: function() {
          //dosometing();     // 分享取消，取消之后要做的事情
        }
      };
      const shareinfo2 = {
        title: share.title,// 分享出去的title
        desc: share.desc,  // 描述信息
        imgUrl: shareimg,  // 分享的小图标
        link: share.url,   // 分享的除去的url
        success: function() {
          if(share.callmethod){
            setTimeout(share.callmethod, 500);
          }
          if(share.callmethod2){
            setTimeout(share.callmethod2, 500);
          }
        },
        cancel: function() {
          //dosometing();     // 分享取消，取消之后要做的事情
        }
      };
      wx.onMenuShareTimeline(shareinfo2);
      wx.onMenuShareAppMessage(shareinfo);
    });
  }).catch(() => {

  })
}

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store
})



// WEBPACK FOOTER //
// ./src/main.js